<template>

  <v-container fluid class="pa-0">

    <v-form ref="readCertForm" autocomplete="off" :disabled="componentDisabled">
      <v-layout align-center>

        <v-flex :class="{'ie-flex-fix': isIE}">
          <app-text-field :value="certFileName" readonly label="appSignCloudKeyPrivateKeyFileSystemReader.certficateSelection"
            :clearable="!componentDisabled" required class="app-sign-text-field" :validate-on-blur="false" @click:clear="clearCertFile">
          </app-text-field>
        </v-flex>

        <v-btn :disabled="componentDisabled" color="primary" class="ml-2 mt-1" @click="openCertSelectDlg">
          {{$t('appSignCloudKeyPrivateKeyFileSystemReader.select')}}
        </v-btn>

        <input ref="certSelectInput" type="file" hidden accept="application/x-x509-ca-cert" @change="onFileChange">

      </v-layout>

      <v-layout align-center>

        <app-password-field ref="password" v-model="keyPassword" :disabled="componentDisabled"
          label="appSignCloudKeyPrivateKeyFileSystemReader.privateKeyPassword" autocomplete="on" name="file-signature-password"
          :class="{'ie-flex-fix': isIE}" class="app-sign-text-field" required :minPasswordLen="1" :validate-on-blur="false"
          @input="onKeyPasswordInput">
        </app-password-field>

      </v-layout>

    </v-form>

    <div v-if="messageText" v-html="messageText" :class="[ 'info-panel pa-2', messageIsError ? 'error': 'success' ]">
    </div>

  </v-container>

</template>

<script>
import debounce from 'lodash/debounce';

import AppTextField from '@/components/Common/AppTextField';
import AppPasswordField from '@/components/Common/AppPasswordField';
import uiMixin from '@/mixins/ui-mixin';
import { actions as _act } from '@/models/store.actions';
import AppSignBasePrivateKeyReader from '@/sign/components/AppSignBasePrivateKeyReader';
import { CloudProvider, CloudKeyReaderType } from '@/sign/models/sign-constants';
import { logger } from '@/helpers/log.service';

export default {
  name: 'AppSignCloudKeyPrivateKeyFileSystemReader',
  extends: AppSignBasePrivateKeyReader,
  components: { AppPasswordField, AppTextField },
  mixins: [uiMixin],
  inject: ['isMobileOnly', 'isIE'],
  data() {
    return {
      certFileName: '',
      certFile: '',
      keyReaderType: CloudKeyReaderType.FileSystem
    };
  },
  computed: {
    isReadyToSign() {
      return !!this.certFile && !!this.keyPassword;
    }
  },
  created() {
    this.prepareComponent();
  },
  methods: {
    prepareComponent() {
      this.fillStateFromStore();
    },

    fillStateFromStore() {
      let cloudProvider = this.getCloudProviderDataFromStore();
      this.certFileName = cloudProvider.certFileName || '';
      this.certFile = cloudProvider.certFile || '';
    },
    getCloudProviderDataFromStore() {
      let cloudProvider = this.isSeal
        ? this.$store.getters[_act.SIGN_GET_CLOUD_PROVIDER_SEAL](CloudProvider.CloudKey)
        : this.$store.getters[_act.SIGN_GET_CLOUD_PROVIDER](CloudProvider.CloudKey);
      return cloudProvider || {};
    },
    saveCloudDataToStore() {
      let act = this.isSeal ? _act.SIGN_MUT_CLOUD_PROVIDER_SEAL : _act.SIGN_MUT_CLOUD_PROVIDER;
      this.$store.commit(act, {
        selectedCloud: CloudProvider.CloudKey,
        cloudProvider: {
          certFileName: this.certFileName,
          certFile: this.certFile
        }
      });
    },

    async appendAdditionalSigningParams(prms) {
      if (prms) {
        if (!prms.data) prms.data = {};
        prms.data.certificate = this.certFile;
        prms.data.privateKeyPassword = this.keyPassword;
      }
      return prms;
    },
    openCertSelectDlg() {
      this.clearCertFile();
      this.$refs.certSelectInput.click();
    },
    clearCertFile() {
      this.certFile = null;
      this.certFileName = '';
      this.$refs.certSelectInput.value = '';
      this.$nextTick(() => this.validateForm());
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const arr = event.target.result.split('base64,');
          if (arr && arr.length > 1) {
            this.certFile = arr[1];
            this.certFileName = files[0].name;
            this.saveCloudDataToStore();
            this.setFocusToPswControl();
            this.$nextTick(() => this.validateForm());
          }
        };
        reader.readAsDataURL(files[0]);
      }
    },

    setFocusToPswControl() {
      const inputs = this.$refs.password.$el.children[1].getElementsByTagName('input');
      if (inputs && inputs.length) {
        inputs[0].focus();
      }
    },
    onKeyPasswordInput: debounce(function() {
      this.validateForm();
    }, 500),
    validateForm() {
      if (this.$refs.readCertForm && this.$refs.readCertForm.validate()) {
        this.$emit('ready');
      } else {
        this.$emit('not-ready');
      }
    },
    onComponentBecameVisible() {
      logger.debug(`[${this.$options.name}:onComponentBecameVisible]`);
      this.eventBus.$emit('app-sign-change-ui-settings', {
        isResetBtnVisible: false
      });
      this.validateForm();
    },
    async tryToReadKey() {
      this.validateForm();
    },
    onPrepareComponent() {
      this.$refs.readCertForm.resetValidation();
    }
  }
};
</script>
